module.exports = __webpack_public_path__ + "img/img_residencial4.09ee1c21.png";